import { DOCUMENTS } from '../actions/documents';

const InitialState = {
  documents: null,
};

// REDUCERS
export default function (state = InitialState, action) {
  switch (action.type) {
    case DOCUMENTS.GET_DOCUMENTS:
      return Object.assign({}, state, {
        documents: action.documents,
      });
    default:
      return state;
  }
}
